export default {
    //Page builder
    domObject: {result: "", entities: {root: {}, contents: {}}},
    domObjectViewer: {},
    PageBuilderPages: [],    
}